// ** React Imports
import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'

// ** Component Imports
import { FallbackLoader } from '../../../shared/ui/elements/FallbackLoader'

// ** Styled Components
import { BlankLayoutContentWrapper, BlankLayoutWrapper } from './styles'

interface IProps {
	withBackgroundImage?: boolean
}

export const BlankLayout = ({ withBackgroundImage = true }: IProps) => {
	return (
		<BlankLayoutWrapper>
			<BlankLayoutContentWrapper $withBackgroundImage={withBackgroundImage}>
				<Suspense fallback={<FallbackLoader fullHeight={false} />}>
					<Outlet />
				</Suspense>
			</BlankLayoutContentWrapper>
		</BlankLayoutWrapper>
	)
}
